import {createSelector} from '@ngrx/store';

import {PARTNERS_FEATURE_KEY, selectCustomersModuleState} from '../reducers';

export const selectPartnersState = createSelector(
  selectCustomersModuleState,
  (state) => state[PARTNERS_FEATURE_KEY]
);

export const selectPartnersEntities = createSelector(
  selectPartnersState,
  (state) => state.entities
);

export const selectPartners = createSelector(
  selectPartnersEntities,
  (customers) => Object.keys(customers).map(iri => customers[iri])
);

/////////////////////////////////////////////////////////////////////////////////////////////////////////////// Search

export const selectSearchResultsIris = createSelector(
  selectPartnersState,
  state => state.searchEntities
);

export const selectSearchResults = createSelector(
  selectPartnersEntities,
  selectSearchResultsIris,
  (entities, selection) => selection.map(key => entities[key])
);

//////////////////////////////////////////////////////////////////////////////////////////////////////////// Pagination

export const selectPartnersTotal = createSelector(
  selectPartnersState,
  state => state.totalItems
);
export const selectPartnerPagination = createSelector(
  selectPartnersState,
  (state) => state.pagination
);
export const selectPaginationCurrentLink = createSelector(
  selectPartnerPagination,
  pagination => pagination.current
);
export const selectPaginationFirstLink = createSelector(
  selectPartnerPagination,
  pagination => pagination.first
);
export const selectPaginationPreviousLink = createSelector(
  selectPartnerPagination,
  pagination => pagination.previous
);
export const selectPaginationNextLink = createSelector(
  selectPartnerPagination,
  pagination => pagination?.next
);
export const selectPaginationLastLink = createSelector(
  selectPartnerPagination,
  pagination => pagination.last
);

//////////////////////////////////////////////////////////////////////////////////////////////////////// Loading States

export const isLoading = createSelector(
  selectPartnersState,
  state => state.loading
);

export const isLoaded = createSelector(
  selectPartnersState,
  state => state.loaded
);

//////////////////////////////////////////////////////////////////////////////////////////////////////////////// Errors

export const selectPartnersErrors = createSelector(
  selectPartnersState,
  (state) => state.errors
);
